<template>
    <div class="no-controller">
        <div class="tips-img">
            <img src="../assets/image/connect_tips.jpg" alt="">
        </div>
        <div class="tips-text">请在手机云班课上点击投屏，完成连接</div>
    </div>
</template>

<script>
export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            
        };
    },
    created: function() {

    }
};
</script>

<style>
    .no-controller{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .tips-img{
        width: 335px;
        height: 600px;
        margin-right: 130px; 
    }
    .tips-img>img{
        width: 100%;
        height: 100%;
    }
    .tips-text{
        font-size: 36px;
        color: #ffffff;
    }
</style>